import ModalComponent from "..";
import { useDeleteAdminMutation } from "../../../redux/features/admin/admin.api";
import { BaseApiErrorResponse, ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { InfoComponent } from "../../notification/infoComponent";

export const DeleteAdminModal = ({
  open,
  handleClose,
  onSuccess,
  adminName,
  adminId,
  refetchAdmin,
}: ModalCompProps & {
  onSuccess: () => void;
  adminName: string;
  adminId: string;
  refetchAdmin: () => void;
}) => {
  const [deleteAdmin, { isLoading, isError, error }] = useDeleteAdminMutation();

  const handleDelete = async () => {
    const resp = await deleteAdmin(adminId);
    if (resp.data?.status === "success") {
      onSuccess();
      refetchAdmin()
      handleClose();
    }
  };

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title={`Delete ${adminName}`}
      subtitle={
        "This will completely remove access from the Backoffice. They will no longer be able to log in with their credentials."
      }
      showIcon={true}
      iconType="trash"
      iconWidth={21}
      iconHeight={21}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <div className="flex flex-col gap-2.5">
        {isError && (
          <InfoComponent
            title="Error"
            text={
              (error as unknown as BaseApiErrorResponse)?.data?.message ??
              "An error occurred!"
            }
            type="error"
          />
        )}
        <div className="col-span-full flex items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Delete"}
            type="submit"
            onClick={handleDelete}
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"danger"}
          />
        </div>
      </div>
    </ModalComponent>
  );
};
